import React from 'react';
import PieChart from './PieChart';

const AnalysisTypeChart = ({ data, totalEmails, onChartClick }) => {
  // Données par défaut pour les 4 types d'analyse
  const defaultAnalysisTypes = [
    { label: 'Analyse de sentiment', value: 0 },
    { label: 'Classification thématique', value: 0 },
    { label: 'Extraction entités', value: 0 },
    { label: 'Analyse syntaxique', value: 0 }
  ];

  // Si nous avons des données réelles, nous les utilisons, sinon données par défaut
  const analysisData = data && data.length > 0 ? data : defaultAnalysisTypes;

  // Couleurs spécifiques pour chaque type d'analyse
  const analysisColors = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6'];

  return (
    <div className="space-y-4" onClick={() => onChartClick && onChartClick('analysis_types')}>
      <div className="text-center">
        <h6 className="font-semibold text-slate-700">Répartition des types d'analyse</h6>
        <p className="text-sm text-slate-500">
          {totalEmails || 0} emails analysés avec 4 types d'analyse par email
        </p>
      </div>

      <PieChart 
        data={analysisData}
        title=""
        colors={analysisColors}
        size={180}
        showLegend={true}
        showPercentage={true}
      />

      {/* Métriques détaillées */}
      <div className="grid grid-cols-2 gap-3 text-center">
        <div className="bg-blue-50 rounded-lg p-2">
          <div className="text-lg font-bold text-blue-600">
            {analysisData[0]?.value || 0}
          </div>
          <div className="text-xs text-blue-700">Analyses sentiment</div>
        </div>
        <div className="bg-green-50 rounded-lg p-2">
          <div className="text-lg font-bold text-green-600">
            {analysisData[1]?.value || 0}
          </div>
          <div className="text-xs text-green-700">Classifications</div>
        </div>
        <div className="bg-amber-50 rounded-lg p-2">
          <div className="text-lg font-bold text-amber-600">
            {analysisData[2]?.value || 0}
          </div>
          <div className="text-xs text-amber-700">Entités extraites</div>
        </div>
        <div className="bg-purple-50 rounded-lg p-2">
          <div className="text-lg font-bold text-purple-600">
            {analysisData[3]?.value || 0}
          </div>
          <div className="text-xs text-purple-700">Analyses syntaxiques</div>
        </div>
      </div>

      {/* Explication des types d'analyse */}
      <div className="bg-slate-50 rounded-lg p-3">
        <h6 className="font-semibold text-slate-700 text-sm mb-2">Types d'analyse effectués :</h6>
        <ul className="text-xs text-slate-600 space-y-1">
          <li>• <strong>Sentiment</strong> : Évaluation positive/négative/neutre</li>
          <li>• <strong>Classification</strong> : Catégorisation par thème</li>
          <li>• <strong>Entités</strong> : Extraction noms, dates, lieux</li>
          <li>• <strong>Syntaxique</strong> : Structure grammaticale</li>
        </ul>
      </div>
    </div>
  );
};

export default AnalysisTypeChart;